<div (click)="onTapped.emit()" class="form-field-label" id="link">
  <a *ngIf="url" [href]="url" target="_blank">{{ text }}</a>
  <div *ngIf="!url">{{ text }}</div>
</div>
